/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Linked_AndroidInputs */

const en_plan_linked_android = /** @type {(inputs: Plan_Linked_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You linked your payment via an android device`)
};

const es_plan_linked_android = /** @type {(inputs: Plan_Linked_AndroidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vinculaste tu pago a través de un dispositivo Android`)
};

/**
* | output |
* | --- |
* | "You linked your payment via an android device" |
*
* @param {Plan_Linked_AndroidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_linked_android = /** @type {((inputs?: Plan_Linked_AndroidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Linked_AndroidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_linked_android(inputs)
	return en_plan_linked_android(inputs)
});